/* eslint-disable @typescript-eslint/ban-ts-comment */
import { forwardRef, useEffect, useRef } from 'react'
import { PromptInput } from './styles'

const AutoExpandingPromptInput = forwardRef<HTMLTextAreaElement, React.ComponentProps<'textarea'>>(
  (props, ref) => {
    const textareaRef = useRef<HTMLTextAreaElement | null>(null)

    const adjustHeight = () => {
      const textarea = textareaRef.current
      if (textarea) {
        textarea.style.height = '64px'
        textarea.style.height = `${Math.min(textarea.scrollHeight, 200)}px`
      }
    }

    useEffect(() => {
      adjustHeight()
    }, [])

    return (
      <PromptInput
        // @ts-ignore
        ref={el => {
          textareaRef.current = el
          if (typeof ref === 'function') ref(el)
          else if (ref) ref.current = el
        }}
        {...props}
        rows={1}
        onInput={adjustHeight}
      />
    )
  },
)

export default AutoExpandingPromptInput
